var DefaultQueryValues;
(function (DefaultQueryValues) {
    DefaultQueryValues["Culture"] = "en";
})(DefaultQueryValues || (DefaultQueryValues = {}));

export { DefaultQueryValues };
